module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-Medium.cc89909a.ttf";